const e={"& a":{color:`primary.main`},"& h1, & h2, & h3, & h4, & h5, & h6":{mt:1,mb:.5},"& p":{my:.5},"& ul, & ol":{pl:3},wordBreak:`break-word`};export{e as termsHtmlContentStyles};
//# sourceMappingURL=terms-html-content-styles.mjs.map